import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

Sentry.init({
    dsn: 'https://da22c27def8142448f4e6ccebc0e8882@o4508714918871040.ingest.de.sentry.io/4509977663111248',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: []
});

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
